import FilmSchoolStudioImage from "../assets/images/blogs/film-school-and-studio-same-company.jpg";
import AIFilmmakersImage from "../assets/images/blogs/ai-filmmakers.jpg"; 

export const seoContent = {
  home: {
    title: "HKI Media | AVGC-XR Skilling & Media Production Company in India ",
    description:
      "HKI Media is a media production company in India offering AVGC-XR skilling, film production, advertising, AR/VR technologies, events, and entertainment services.",
    keywords:
      "creative media company, film production company, corporate video production, corporate films, AR VR company, virtual reality technology, AVGC XR skilling, animation training institute, corporate event management, media production company, marketing agency, event production services",
    canonicalUrl: "https://www.hkimedia.com/",
    schema: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "HKI Media",
      url: "https://www.hkimedia.com/",
      description:
        "HKI Media is a creative media and film production Agency offering AVGC-XR skilling, corporate films, AR/VR, advertisement and events across India.",
      publisher: {
        "@type": "Organization",
        name: "HKI Media Pvt. Ltd.",
        url: "https://www.hkimedia.com/",
        logo: {
          "@type": "ImageObject",
          url: "https://media-metrix-dev.s3.ap-south-1.amazonaws.com/WhatsApp+Image+2025-01-02+at+3.32.15+PM.jpeg",
        },
        email: "support@hkimedia.com",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          email: "support@hkimedia.com",
          areaServed: "IN",
          availableLanguage: ["English", "Hindi"],
        },
      },
      inLanguage: "en-IN",
    },
  },
  skilling: {
    title: "HKI Media | AVGC-XR & Film Production Training in India",
    description:
      "Explore AVGC-XR, animation, VFX, gaming, film production, and digital media training in India with industry-led programs and career support.",
    keywords:
      "AVGC XR skilling, animation training institute, visual effects training, 3D animation course, VFX training, game development courses, filmmaking certificate, media training institute",
    canonicalUrl: "https://www.hkimedia.com/hki-animatica",
    schema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Who Can Buy an ICASA Franchise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The ICASA franchise is perfect for media organizations, educational institutions, or media agencies looking to dominate India’s rapidly evolving creative market. If you’re ready to make it big, this is your opportunity!",
          },
        },
        {
          "@type": "Question",
          name: "When Does the First Batch Start?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The first batch of ICASA students will commence their journey in June 2025. Be part of this revolutionary launch and start shaping the future of India’s creative minds!",
          },
        },
        {
          "@type": "Question",
          name: "What Is the Franchise Fee?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "There’s no franchise fee! Simply choose the courses you wish to offer, and our expert team will assist you in setting up your ICASA Centre of Excellence.",
          },
        },
        {
          "@type": "Question",
          name: "Which Courses Are Offered by ICASA?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For detailed information about our wide range of courses, reach out to our support email or fill out the interest form. Our team will guide you through the options tailored to your needs.",
          },
        },
        {
          "@type": "Question",
          name: "Where Can I Open an ICASA COE?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can open an ICASA Centre of Excellence anywhere in India with good connectivity and infrastructure. For detailed prerequisites, fill out the interest form, and our team will assist you.",
          },
        },
      ],
    },
  },
  corporate: {
    title: "HKI Media | Corporate Film & Video Production Company in India",
    description:
      "HKI Media is a corporate film and video production company in Gurugram, India specializing in company profile videos, industrial films, CSR films, and event coverage.",
    keywords:
      "corporate video production, corporate films, corporate branding, business growth strategy, brand strategy consultancy, corporate communication, corporate media production",
    canonicalUrl: "https://www.hkimedia.com/corporate",
  },
  cmYuva: {
    title: "HKI Media | CM Yuva Media Studio Franchise Opportunity",
    description:
      "HKI Media CM Yuva Digital Media Studio franchise offers VFX, animation, digital marketing, content creation and live project opportunities via GigMedia.",
    keywords:
      "CM Yuva scheme, CM Yuva Udyami Yojana, skill development program, government training scheme, entrepreneurship development, youth skilling program",
    canonicalUrl: "https://www.hkimedia.com/gigmatic-studios",
  },
  entertainment: {
    title: "HKI Media | Music Video & Film Production Company in India",
    description:
      "HKI Media Entertainment produces multilingual films, music videos, and regional content, creating engaging entertainment for audiences across India.",
    keywords:
      "film production company, music video production, entertainment show management, multilingual film production, media production company, film production studios",
    canonicalUrl: "https://www.hkimedia.com/entertainment",
  },
  marketing: {
    title: "HKI Media | Advertising Company & Creative Services in India ",
    description:
      "HKI Media is an advertising company in Gurugram, India, delivering creative campaigns, media planning, and digital engagement solutions.",
    keywords:
      "marketing agency, advertising agency, creative ad agency, digital marketing services, brand strategy consultancy, startup marketing solutions, business growth strategy",
    canonicalUrl: "https://www.hkimedia.com/marketing",
  },
  arVr: {
    title: "HKI Media | AR/VR Services & Immersive Experiences India",
    description:
      "HKI Media offers AR/VR services, immersive experiences, motion capture, AR filters, XR content, and virtual walkthrough solutions in India.",
    keywords:
      "AR VR company, virtual reality technology, augmented reality solutions, digital twin services, VR training simulation, virtual classroom platform, virtual heritage tours",
    canonicalUrl: "https://www.hkimedia.com/ar-vr",
  },
  event: {
    title: "HKI Media | Best Event Management Company in India",
    description:
      "HKI Media is an event management company in India delivering corporate events, government programs, live shows, and themed experiences with end-to-end execution.",
    keywords:
      "corporate event management, event production services, event planning company, entertainment event management, government event management Gurgaon, corporate event planning companies, theme event management",
    canonicalUrl: "https://www.hkimedia.com/event",
  },
  contact: {
    title: "Contact Us | Media & Event Services in Gurugram, India",
    description:
      "Get in touch for corporate events, government programs, and media services. We are available for inquiries, projects, and support across India.",
    canonicalUrl: "https://www.hkimedia.com/contact-us",
  },
  franchise: {
    title: "HKI Studio Franchise Enquiry | Start Your Own Media Studio",
    description:
      "Open an HKI Studio in your tehsil and offer creative, digital marketing, and media services locally. Submit your franchise enquiry today.",
    canonicalUrl: "https://www.hkimedia.com/franchise",
  },
  eventsExperiences: {
    title: "HKI Media | Events & Brand Experiences in India",
    description:
      "HKI Media creates events and immersive brand experiences that bring brands and people together, from concept to on-ground execution.",
    canonicalUrl: "https://www.hkimedia.com/events-experiences",
  },
  influencerMarketing: {
    title: "HKI Media | Influencer Marketing Agency in India",
    description:
      "Influencer marketing by HKI Media: the right creators, the right audience and the right story for campaigns that drive real engagement.",
    canonicalUrl: "https://www.hkimedia.com/influencer-marketing",
  },
  celebrityMarketing: {
    title: "HKI Media | Celebrity Marketing & Endorsements in India",
    description:
      "HKI Media plans celebrity marketing and endorsements with strategy behind the star power, from talent selection to campaign rollout.",
    canonicalUrl: "https://www.hkimedia.com/celebrity-marketing",
  },
  aiContentCreation: {
    title: "HKI Media | AI Content Creation Services in India",
    description:
      "HKI Media blends creativity and AI to produce premium brand content at scale. Create more, create faster, create differently.",
    canonicalUrl: "https://www.hkimedia.com/ai-content-creation",
  },
  news: {
    title:
      "HKI Media | AVGC-XR News, Animation & Gaming Industry Updates in India",
    description:
      "Latest news from HKI Media covering AVGC-XR policy updates, Centre of Excellence initiatives, animation gaming industry and immersive tech in India.",
    canonicalUrl: "https://www.hkimedia.com/news",
  },
  blogs: {
    title:
      "HKI Media Blog | Creative Media, AVGC-XR & Entertainment Industry Insights",
    description:
      "From AVGC-XR to film production, skilling to live events — HKI Media covers every corner of India's media and entertainment industry. Expert insights, one hub.",
    canonicalUrl: "https://www.hkimedia.com/blogs",
  },
  blogAvgcXr: {
    title: " What is AVGC-XR in India & Why is Government Investing in It?",
    description:
      "AVGC-XR in India is growing fast. The animation, VFX and gaming industry is creating jobs while Haryana AVGC-XR Policy 2026 shapes India's creative economy.",
    keywords:
      "what is AVGC-XR, AVGC-XR India, animation gaming VFX India, government push AVGC, creative media industry, skilling in India, immersive media trends",
    canonicalUrl: "https://www.hkimedia.com/blogs/what-is-avgc-xr-in-india",
    schema: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://www.hkimedia.com/blogs/what-is-avgc-xr-in-india",
      },
      headline: "What is AVGC-XR in India? Govt Push & Growth Explained",
      description:
        "Understand what AVGC-XR in India is and why the government is investing heavily. Explore its impact across animation, gaming, VFX, and the creative industry.",
      image:
        "https://www.hkimedia.com/static/media/AVGCXR.273946ab08d147d49dff.jpg",
      author: {
        "@type": "Organization",
        name: "HKI Media",
      },
      publisher: {
        "@type": "Organization",
        name: "HKI Media",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hkimedia.com/static/media/Logo.5051939f796b909b9da3d857474b1d9e.svg",
        },
      },
    },
  },
  blogFilmSchoolAndStudio: {
    title: "What If the Film School and Film Studio Were the Same Company?",
    description:
      "What if India's film school and studio shared one payroll? From old Bollywood to OTT labs, here's why this idea could completely reshape Indian cinema.",
    canonicalUrl:
      "https://www.hkimedia.com/blogs/what-if-film-school-and-film-studio-were-same-company",
    schema: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hkimedia.com/blogs/what-if-film-school-and-film-studio-were-same-company",
      },
      headline:
        "What If the Film School and the Film Studio Were the Same Company?",
      description:
        "What happens when the classroom and the film set share the same payroll? From Subhash Ghai's Whistling Woods experiment to OTT writers' labs, this piece traces why India's film industry keeps circling back to one uncomfortable question — should the studio just build its own school?",
      image: window.location.origin + FilmSchoolStudioImage,
      author: {
        "@type": "Organization",
        name: "HKI Media",
      },
      publisher: {
        "@type": "Organization",
        name: "HKI Media",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hkimedia.com/static/media/Logo.5051939f796b909b9da3d857474b1d9e.svg",
        },
      },
    },
  },
  blogAiFilmmakers: {
    title: "AI Can Make Movies. But Can It Ever Replace Filmmakers?",
    description:
      "Can AI replace filmmakers? As AI in filmmaking transforms film & video production, human creativity continues to define the future of filmmaking in India.",
    canonicalUrl:
      "https://www.hkimedia.com/blogs/ai-can-make-movies-but-can-it-ever-replace-filmmakers",
    schema: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://www.hkimedia.com/blogs/ai-can-make-movies-but-can-it-ever-replace-filmmakers",
      },
      headline:
        "AI Can Make Movies. But Can It Ever Replace Filmmakers?",
      description:
        "Can AI replace filmmakers? As AI in filmmaking transforms film & video production, human creativity continues to define the future of filmmaking in India.",
      image: window.location.origin + AIFilmmakersImage, // Matches new import
      author: {
        "@type": "Organization",
        name: "HKI Media",
      },
      publisher: {
        "@type": "Organization",
        name: "HKI Media",
        logo: {
          "@type": "ImageObject",
          url: "https://www.hkimedia.com/static/media/Logo.5051939f796b909b9da3d857474b1d9e.svg",
        },
      },
    },
  },
};